import { Preload } from './Preload'
import type { PreloadDataAccessObject } from './PreloadDataAccessObject'

export class PreloadEncoder {
  static encode(instance: Preload) {
    return {
      productIds: instance.selection.value,
      step: instance.step.value,
    }
  }

  static decode(properties: PreloadDataAccessObject) {
    return new Preload(properties.productIds, properties.step)
  }
}
